import React from 'react';
import { Typography, Stack, Box } from '@mui/material';

const TotalsDisplay = ({ formTotaling, grandTotal, approvedTotal, completedTotal, pendingTotal, partsTotal, laborTotal, vehiclePartsTotal }) => (
  <Box sx={{ mb: 2, p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
    <Stack direction="row" spacing={3} justifyContent="flex-end" flexWrap="wrap">
      {formTotaling.approved?.enabled && <Typography><strong>Approved:</strong> ${approvedTotal}</Typography>}
      {formTotaling.completed?.enabled && <Typography><strong>Completed:</strong> ${completedTotal}</Typography>}
      {formTotaling.pending?.enabled && <Typography><strong>Pending:</strong> ${pendingTotal}</Typography>}
      {Number(vehiclePartsTotal) > 0 && <Typography><strong>Vehicle Parts:</strong> ${Number(vehiclePartsTotal).toFixed(2)}</Typography>}
      {formTotaling.grand?.enabled && <Typography><strong>Grand Total:</strong> ${grandTotal}</Typography>}
      {formTotaling.parts?.enabled && <Typography><strong>Parts Total:</strong> ${partsTotal}</Typography>}
      {formTotaling.labor?.enabled && <Typography><strong>Labor Total:</strong> ${laborTotal}</Typography>}
    </Stack>
  </Box>
);

export default TotalsDisplay;